




















































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component({
  metaInfo() {
    return {
      title: `${this.$t('meta.legalMentionsTitle')}`,
      htmlAttrs: {
        lang: this.$root.$i18n.locale
      },
      meta: [
        {
          name: 'description',
          content: `${this.$t('meta.legalMentionsDescription')}`
        },
        {
          name: 'og:title',
          content: `${this.$t('meta.legalMentionsTitle')}`
        },
        {
          name: 'og:description',
          content: `${this.$t('meta.legalMentionsDescription')}`
        },
        {
          name: 'twitter:title',
          content: `${this.$t('meta.legalMentionsTitle')}`
        },
        {
          name: 'twitter:description',
          content: `${this.$t('meta.legalMentionsDescription')}`
        }
      ]
    }
  }
})
export default class LegalMentions extends Vue {

}
